<script setup>
defineProps({
  errorState: { type: Object, required: true },
  backTo: { type: String, required: true },
  backToLabel: { type: String, required: true },
  itemLabel: { type: String, required: true },
});
</script>

<template>
  <div
    class="
      tw:flex tw:h-[80dvh] tw:w-full tw:items-center tw:justify-center tw:py-24
    "
  >
    <div class="tw:max-w-[380px] tw:text-center">
      <h2 class="tw:mb-2">{{ errorState.title }}</h2>
      <p class="tw:mb-4 tw:text-base tw:text-neutral-60">
        {{ errorState.description }}
      </p>
      <p class="tw:text-sm tw:text-neutral-60">
        <span class="tw:font-semibold">Note:</span>
        Head back to the
        <router-link :to="backTo" class="tw:font-semibold tw:text-primary">{{
          backToLabel
        }}</router-link>
        page to view your {{ itemLabel }}.
      </p>
    </div>
  </div>
</template>
